import { Heading, Stack, Text, TextDropdown } from 'braid-design-system';
import { useState } from 'react';

import { NotiHistoryProvider, useNotiHistory } from './HistoryContext.tsx';
import { HistoryList } from './components/HistoryList/HistoryList.tsx';

export const HistoryContent = () => {
  const [notiTypeFilter, setNotiTypeFilter] = useState('All Notifications');
  const { uniqueNotiTitles } = useNotiHistory();

  const formattedOptions = [
    { text: 'all notifications', value: 'All Notifications' },
    ...uniqueNotiTitles.map((noti) => ({
      text: noti.toLocaleLowerCase(),
      value: noti,
    })),
  ];

  return (
    <Stack space="medium">
      <Heading level="3">Recent notifications</Heading>

      {uniqueNotiTitles.length > 1 ? (
        <Text>
          Showing{' '}
          <TextDropdown
            id="notificationType"
            label="Notification Type"
            options={formattedOptions}
            value={notiTypeFilter}
            onChange={setNotiTypeFilter}
          />
        </Text>
      ) : null}

      <HistoryList notiType={notiTypeFilter} />
    </Stack>
  );
};

export const HistorySection = () => (
  <NotiHistoryProvider>
    <HistoryContent />
  </NotiHistoryProvider>
);
